<template>
  <v-container
    :disabled="disabled"
    grid-list-md
    style="padding: 0;"
  >
    <!--    <span>{{disabled}}, Sel.wells: {{ selected_wells }}</span>-->
    <v-card style="margin-bottom: 16px;">
      <v-card-title>Wells' props</v-card-title>
      <v-card-text>
        <v-layout row>

          <!-- sample -->
          <v-flex lg3 md6 xs12>
            <v-select label="Sample" dense outlined hide-details
                      v-model="for_all.sample_id"
                      :placeholder="for_all.sample_placeholder"
                      :items="sample_items" item-value="id" item-text="name"
                      :disabled="disabled">
            </v-select>
          </v-flex>

          <v-flex lg3 md6 xs12>
            <v-select label="Treat" dense outlined hide-details
                      v-model="for_all.treat_id"
                      :placeholder="for_all.treat_placeholder"
                      :items="treat_list" item-value="id" item-text="name"
                      :disabled="disabled">
            </v-select>
          </v-flex>

          <!-- probePlex -->
          <v-flex lg3 md6 xs12>
            <v-select label="Probe plex" dense outlined hide-details
                      v-model="for_all.probePlex_id"
                      :placeholder="for_all.probePlex_placeholder"
                      :items="probePlex_list" item-value="id" item-text="name"
                      :disabled="disabled">
            </v-select>
          </v-flex>

          <!-- color -->
          <v-flex lg3 md6 xs12>
            <color-picker-select label="Color" ref="ctrlColor" dense outlined
                                 v-model="for_all.color"
                                 :placeholder="for_all.color_placeholder"
                                 :disabled="disabled">
            </color-picker-select>
          </v-flex>

          <!-- notes -->
          <v-flex lg11 md11 xs11>
            <v-text-field label="Notes" dense outlined hide-details
                          v-model="for_all.notes"
                          :placeholder="for_all.notes_placeholder"
                          :disabled="disabled">
            </v-text-field>
          </v-flex>

          <v-flex lg1 md1 xs1>
            <v-btn icon @click="apply()">
              <v-icon>mdi-content-save-settings</v-icon>
            </v-btn>
          </v-flex>

        </v-layout>
      </v-card-text>
    </v-card>

    <!-- Probes background settings override -->
    <span>Probes' background settings override</span>
    <v-layout>
      <v-data-table dense disable-sort
                    :headers="plate_wells_probes_headers"
                    :items="for_all.data.probes"
                    :items-per-page="-1" :hide-default-footer="true">

        <template #item.probe_name="{ item }">
          <v-tooltip left open-delay="10ms">
            <template #activator="{ on }">
              <div style="min-width: 50px; max-width: 120px; overflow: hidden; cursor: default;"
                   v-on="on">
                {{ plate.probes[item.probe_id].name }}
              </div>
              <!--              <div v-on="on">-->
              <!--                Hallo-->
              <!--              </div>-->
            </template>
            <span> {{ plate.probes[item.probe_id].name }} </span>
          </v-tooltip>
        </template>

        <template #item.dye_name="{ item }">
          <span :style="{ color: plate.probes[item.probe_id].dye.color }">
            {{ plate.probes[item.probe_id].dye.name }}
          </span>
        </template>

        <template v-slot:item.range_over_start="{ item }">
          <v-text-field :ref="'edtBgRangeOverStart_' + item.probe_id"
                        v-model="item.bg_range_over.start" type="Number"
                        :autofocus="item.bg_range_over.autofocus"
                        :placeholder="item.bg_range_over.start_placeholder"
                        @keypress.enter="edtRangeOver_keyEnter($event, item.probe_id)"
                        outlined dense :hide-details="true"
                        style="min-width: 60px; max-width: 90px;">
          </v-text-field>
        </template>

        <template v-slot:item.range_over_stop="{ item }">
          <v-text-field v-model="item.bg_range_over.stop" type="Number"
                        :placeholder="item.bg_range_over.stop_placeholder"
                        @keypress.enter="edtRangeOver_keyEnter($event, item.probe_id)"
                        outlined dense :hide-details="true"
                        style="min-width: 60px; max-width: 90px;">
          </v-text-field>
        </template>

      </v-data-table>
    </v-layout>

  </v-container>

</template>

<script>

	import {mdiContentSaveSettingsOutline} from '@mdi/js'

	import {Plate} from '../../models'

	import format from 'string-format'
	import {mapActions, mapGetters} from 'vuex'
	import {
		VContainer, VRow, VCol,
		VSelect, VBtn,
	} from 'vuetify'

	import ColorPickerSelect from "../base/ColorPickerSelect"
	import {Probe} from "../../models/Probe"

	export default {
		name: "wells-props",

		components: {
			VContainer, VRow, VCol,
			VSelect, VBtn,
			'color-picker-select': ColorPickerSelect
		},

		data: function () {
			return {
				plate_wells_probes_headers: [
					{text: "Probe name", align: 'start', value: 'probe_name',},
					{text: "id", align: 'end', value: 'probe_id',},
					{text: "Dye", align: 'start', value: 'dye_name',},
					{text: "bg_start", align: 'start', value: 'range_over_start',},
					{text: "bg_stop", align: 'start', value: 'range_over_stop',},
				],

				for_all: {
					sample_id: null,
					probePlex_id: null,
					notes: null,
					color: '#808080',

					sample_placeholder: null,
					probePlex_placeholder: null,
					notes_placeholder: null,
					color_placeholder: null,

					// probe_data_bg_over must be an Array for v-data-table
					data: {
						probes: []
					},
				},
			}
		},

		props: {
			disabled: {type: Boolean, default: false,},
			plate: {type: Plate, default: () => Plate.empty_plate,},
			selected_wells: {type: Array, default: () => [],},
			selected_probes: {type: Array, default: () => [],},
		},

		watch: {
			disabled: function (new_value, old_value) {
				console.debug(format(
					"WellsPropsComponent.watch.disabled( {0} )",
					new_value))
				if (!this.disabled) {
					this.update_view()
				}
			},

			plate: function (new_value, old_value) {
				this.update_view()
			},

			selected_wells: function (new_value, old_value) {
				this.update_view()
			},
			selected_probes: function (new_value, old_value) {
				this.update_view()
			},
		},

		computed: {
			...mapGetters({
				sample_items: 'sample/sample_list',
				treat_list: 'lists/treat_list',
				probePlex_list: 'probePlex/probePlex_list',
			}),
		},

		mounted: function () {
			console.debug(format("WellsPropsComponent.mounted()"))

			this.update_view()
		},

		methods: {
			...mapActions({
				message_add: 'message/add',

				progress_begin: 'progress/begin',
				progress_end: 'progress/end',
			}),

			apply: function () {

				const me = this
				me.progress_begin({message: "Update wells' properties ..."})
				return this.$store.dispatch('plate/update_wells', {
					plate: this.plate,
					well_nums: this.selected_wells,
					props: this.for_all
				})
					.then(function () {
						me.message_add({type: 'success', html: "Wells props updated"})
						me.$emit('apply')
					})
					.catch(function (error) {
						me.message_add(error)
					})
					.finally(function () {
						me.update_view()
						me.progress_end()
					})
			},

			/**
			 * Проверяем, что у всех выбранных лунок одинаковое
			 * значение свойства и устанавливаем поля в data
			 */
			update_view: function () {

				if (!this.disabled) {

					const selected_wells = Array.from(
						this.selected_wells,
						(well_num) => this.plate.wells[well_num])

					const probe_list2 = Object.values(this.plate.probes)
						.filter((probe) => probe.id !== -1000)
						.sort(Probe.compare_probes_by_dye_order)

					// попробуем показывать только зонды, которые есть в выделенных лунках
					const probe_list = [...new Set(
						[].concat.apply([], selected_wells.map((well) => well.probes))
					)].map((probe_id) => this.plate.probes[probe_id])
						.filter((probe) => probe.id !== -1000)
						.sort(Probe.compare_probes_by_dye_order)

					let kk = 17

					const for_all = selected_wells.reduce(function (a, b) {
						return {
							// region -- sample, probePlex, color, notes --
							sample_id: !a ? b.sample_id
								: (a.sample_id === b.sample_id ? a.sample_id : null),

							treat_id: !a ? b.treat_id
								: (a.treat_id === b.treat_id ? a.treat_id : null),

							probePlex_id: !a ? b.probePlex_id
								: (a.probePlex_id === b.probePlex_id ? a.probePlex_id : null),

							color: !a ? b.color
								: (a.color === b.color ? a.color : ''),

							notes: !a ? b.notes
								: (a.notes === b.notes ? a.notes : null),

							sample_placeholder: !a ? null : ((
								a.sample_placeholder ||
								a.sample_id !== b.sample_id) ? "multiple" : null),

							treat_placeholder: !a ? null : ((
								a.treat_placeholder ||
								a.treat_id !== b.treat_id) ? "multiple" : null),

							probePlex_placeholder: !a ? null : ((
								a.probePlex_placeholder ||
								a.probePlex_id !== b.probePlex_id) ? "multiple" : null),

							notes_placeholder: !a ? null : ((
								a.notes_placeholder ||
								a.notes !== b.notes) ? "multiple" : null),

							color_placeholder: !a ? null : ((
								a.color_placeholder ||
								a.color !== b.color) ? "multiple" : null),

							// endregion -- sample, probePlex, color, notes --

							data: {
								probes: this.probe_list
									.map(function (probe, probe_i) {
										const probe_id = probe.id

										const a_pd = this.a && this.a.data.probes
											? this.a.data.probes[probe_i] : null
										// Well.probe_data_bg is a dict by probe_id
										const b_pd = this.b && this.b.data.probes
											? this.b.data.probes[probe_id] : null

										// b_pdbg can be null or undefined
										const ro_a = a_pd && 'bg_range_over' in a_pd ? a_pd.bg_range_over : null
										const ro_b = b_pd && 'bg_range_over' in b_pd ? b_pd.bg_range_over : null

										const a_start = ro_a != null ? ro_a.start : null
										const a_stop = ro_a != null ? ro_a.stop : null
										const b_start = ro_b != null ? ro_b.start : null
										const b_stop = ro_b != null ? ro_b.stop : null

										const res = {
											probe_id: probe_id,
											bg_range_over: {
												start: !a ? b_start : (a_start === b_start ? a_start : null),
												stop: !a ? b_stop : (a_stop === b_stop ? b_stop : null),

												autofocus: this.selected_probes.length === 1 &&
													this.selected_probes[0] === probe_id,

												start_placeholder: !a ? null : ((
													ro_a.start_placeholder ||
													a_start !== b_start) ? "**" : null),

												stop_placeholder: !a ? null : ((
													ro_a.stop_placeholder ||
													a_stop !== b_stop) ? "**" : null),
											}
										}
										return res
									}, {a, b, selected_probes: this.selected_probes})
							}
						}
					}.bind({
						probe_list: probe_list,
						selected_probes: this.selected_probes
					}), null)


					// With empty selected_wells for_all results null
					this.for_all = for_all != null ? for_all : { // first element for reduce
						sample_id: null,
						treat_id: null,
						probePlex_id: null,
						notes: null,
						color: '#808080',

						sample_placeholder: null,
						treat_placeholder: null,
						probePlex_placeholder: null,
						notes_placeholder: null,
						color_placeholder: null,
						data: {
							probes: probe_list.map(
								function (probe) {
									return {
										probe_id: probe.id,
										bg_range_over: {
											start: null,
											stop: null,
											start_placeholder: null,
											stop_placeholder: null
										}
									}
								})
						}
					}

					let k = 21

					// console.debug(
					// 	"WellsPropsComponent.update_view()\n" +
					// 	format("  sample: '{0}'\n", this.for_all.sample_id) +
					// 	format("  treat: '{0}'\n", this.for_all.treat_id) +
					// 	format("  probePlex: '{0}'\n", this.for_all.probePlex_id) +
					// 	format("  notes: '{0}'\n", this.for_all.notes) +
					// 	format("  color: '{0}'\n", this.for_all.color) +
					// 	format("  probes_over: '{0}'",
					// 		this.for_all.probe_data_bg
					// 			.map(function (pdbg) {
					// 				format("{0}-{1}", pdbg.range_over.start, pdbg.range_over.stop)
					// 			})
					// 			.join("\n"))
					// )
				}
			},

			edtRangeOver_keyEnter: function (e, probe_id) {
				const me = this
				this.apply()
					.then(function () {
						// setTimeout(function () {
						const edt_name = 'edtBgRangeOverStart_' + probe_id
						const edt = me.$refs[edt_name]
						edt.focus()
						//}, 700)
					})
			}
		},
	}
</script>

<style scoped>

</style>